export default __webpack_public_path__ + "static/media/Govardhan@2x.35b52afb.png";